import _ from "lodash"
import React from "react"
import { Navigate, useParams, useLocation } from "react-router-dom"

import { getSession, getCurrentUser } from "../helpers/AuthType/authService"
import {
  getPage,
  getPages,
  initPages,
  setPage,
  isValid,
  getValidPath,
  getParent,
  getPagesById,
} from "../helpers/PageTracker/page-tracker-backend"

const Authmiddleware = props => {
  try {    
    const { pathname } = useLocation()
    const routes = _.split(pathname, '/')
    const params = useParams()
    const session = getSession()
    const user = getCurrentUser()
    
    if(_.isUndefined(session) ||  !_.has(session, 'application') || !session.application)
      return (
        <Navigate to={{ pathname: "/", state: { from: props.location } }} />
      )
    
    if(((routes).includes('co') && !session.coapplication) || (!(routes).includes('co') && session.coapplication))
      return (
        <Navigate to={{ pathname: "/", state: { from: props.location } }} />
      )

      let {app} = session
    
      if(!_.isUndefined(app) && _.has(app, 'access_code_validated') && app.access_code_validated){
        if(_.has(session, 'coapplication') && session.coapplication && !(routes).includes('logout')){
          return (
            <Navigate to={{ pathname: "/logout", state: { from: props.location } }} />
          )
        }else if(!(routes).includes('add-cosigner')){
            <Navigate to={{ pathname: "/add-cosigner", state: { from: props.location } }} />
        }
      }

    return <React.Fragment>{props.children}</React.Fragment>
  } catch (error) {
    console.log({error : error.message})
     
    return (
      <Navigate to={{ pathname: "/", state: { from: props.location } }} />
    )
  }
}

export default Authmiddleware
